import axios from 'axios'
import { Message } from 'element-ui';
import router from "../router";

// 环境的切换
//测试环境
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = '/'
} else if (process.env.NODE_ENV === 'production') {
    //生产环境
    axios.defaults.baseURL = 'https://ai.yixintz.com.cn/'
}

// 请求拦截器
axios.interceptors.request.use(
    config => {
        const token = window.localStorage.getItem("_admintoken_");
        // console.log("token:" + token)
        token && (config.headers.Authorization = token)
        return config
    },
    error => {
        return Promise.error(error)
    })

//axios.defaults.timeout = 10000
axios.defaults.withCredentials = true //跨域
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

const service = axios.create({
    timeout: 10000,
    withCredentials: true,
});
// 响应拦截器
axios.interceptors.response.use(response => {
    if (response.status === 200) {
        if (response.data.code === 511) {
            // 未授权调取授权接口
        } else if (response.data.code === 510) {
            // 未登录跳转登录页
        } else {
            return Promise.resolve(response)
        }
    } else {
        return Promise.reject(response)
    }
}, error => {
    // 我们可以在这里对异常状态作统一处理

    if (error.response.status) {
        // 处理请求失败的情况
        // 对不同返回码对相应处理
        //return Promise.reject(error.response)
        if (error.response.data.message) {
            Message.error({ message: error.response.data.message })
        } else {
            Message.error({ message: '未知错误' })
        }
    }
})

// get 请求
export function httpGet({
    url,
    params = {}
}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params
        }).then((res) => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

// post请求
export function httpPost({
    url,
    data = {},
    params = {},
    //showError
}) {
    /*if (showError || showError == undefined) { // 是否展示错误信息
        showError = true;
    } else {
        showError = false;
    }*/
    return new Promise((resolve, reject) => {
        axios({
            url,
            method: 'post',
            // 发送的数据
            data,
            // url参数
            params,

        }).then(res => {
            // console.log(res.data)
            resolve(res.data);
            /* if (res.data.code == 0) { // 0 是请求成功
                resolve(res.data.data);
           } else { // 其他情况返回错误信息，根据需要处理
                reject(res.data);
                if (showError) {
                    Message.error(res.data.message);
                }
            }*/
        }).catch(() => {
            /*if (showError) {
                Message.error('请求失败，请稍后再试');
            }*/
            //console.log('请求失败，请稍后再试')
        });
    });
}

export default service;



// WEBPACK FOOTER //
// ./src/api/config.js